export default "__VITE_ASSET__DCrcDZ_6__"